import { render, staticRenderFns } from "./TimelineElement.vue?vue&type=template&id=25dc80f6&"
import script from "./TimelineElement.vue?vue&type=script&lang=js&"
export * from "./TimelineElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports